import styled from "styled-components";

import { BodyText, Heading } from "@braze/beacon-core";

export const StyledHeading = styled(Heading)`
  text-align: center;
`;

export const StyledBodyText = styled(BodyText)``;
